import React from 'react';
import { Button, PageContainer } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import { cx } from '../../../helper/cx';
import { Mail, CreditCard } from 'lucide-react';
import './orderConfirmation.css';
import { COMPANY_CONFIG } from '../../../constants/companyConfig';


const OrderConfirmationNode = () => {
  const billingItems = [
    {
      category: 'Internet Services',
      details:
        'Download speed up to 239.12 Mbps, Upload speed up to 240.6 Mbps.',
      cost: 89.95,
    },
    { category: 'Modem Rental', details: 'Provided by PRTC', cost: 0.00 },
    {
      category: 'Estimated Taxes & Fees',
      details: 'Includes government & other fees',
      cost: 0.00,
    },
  ];

  const total = billingItems
    .reduce((sum, item) => sum + item.cost, 0)
    .toFixed(2);

  const installItems = [{ item: 'Installation', type: 'Standard', cost: 0.00 }];

  // Get the signin URL based on environment
  const getSignInUrl = () => {
    const env = process.env.REACT_APP_ENV || 'dev';
    return COMPANY_CONFIG.signInUrl(env);
  };



  return (
    <PageContainer className="orderReceiptNode-Container">
      <div className="orderReceiptNode-checkoutContainer">
        <div className="orderReceiptNode-checkoutHeader">
          <h2>Thank you for your order!</h2>
          <p>
            We sent your confirmation to your email address. <br />
            You can check your order status in your online{' '}
            <span className="orderReceiptNode-loginLink">
            <a 
              id={ELEMENT_IDS.NAVIGATE_TO_SC}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'var(--primary-color)', textDecoration: 'none', cursor: 'pointer' }}
            >
              Subscriber Connect
            </a>{' '}
            </span>
            account.
          </p>
        </div>

        <div className="orderReceiptNode-checkoutContent">
          <div className="orderReceiptNode-checkoutDetails">
            <div className="orderReceiptNode-section">
              <div className="orderReceiptNode-sectionHeader">
                <h4>Your Account</h4>
              </div>
              <div className="orderReceiptNode-sectionContent">
                <div className="orderReceiptNode-sectionContentRow">
                  <span>Name:</span>{' '}
                  <span id={ELEMENT_IDS.ORDER_ACCOUNT_NAME}>Sam Lee</span>
                </div>
                <div className="orderReceiptNode-sectionContentRow">
                  <span>Mobile Phone Number:</span>{' '}
                  <div>
                    {/* <span className="orderReceiptNode-verified">
                      ✔ Verified
                    </span>{' '} */}
                    <span id={ELEMENT_IDS.ORDER_PHONE}>555 321 6789</span>
                  </div>
                </div>
                <div className="orderReceiptNode-sectionContentRow">
                  <span>Email Address:</span>{' '}
                  <div>
                    {/* <span className="orderReceiptNode-verified">
                      ✔ Verified
                    </span>{' '} */}
                    <span id={ELEMENT_IDS.ORDER_EMAIL}>sam.lee@gmail.com</span>
                  </div>
                </div>
                <div className="orderReceiptNode-sectionContentRow">
                  <span>Service Address:</span>{' '}
                  <span id={ELEMENT_IDS.ORDER_ADDRESS}>
                    1963 Winding Creek Road DR. Walterboro, SC, 120168
                  </span>
                </div>
                <div className="orderReceiptNode-sectionContentRow" style={{ justifyContent: 'flex-end' }}>
                  <span className="orderReceiptNode-loginLink" >
                    <a 
                      id={ELEMENT_IDS.NAVIGATE_TO_SC_LOGIN}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: 'var(--primary-color)', textDecoration: 'none', cursor: 'pointer' }}
                    >
                      Login to your Subscriber Connect Account
                    </a>{' '}
                    
                  </span>
                </div>
              </div>
            </div>

            <div className="orderReceiptNode-section">
              <div className="orderReceiptNode-sectionHeader">
                <h4>Monthly Charges</h4>
              </div>
              <div className="orderReceiptNode-table">
                <div className="orderReceiptNode-row orderReceiptNode-header">
                  <div>Category</div>
                  {/* <div>Details</div> */}
                  <div>Cost (Monthly)</div>
                </div>
                <hr className="orderReceiptNode-separator" />
                {billingItems.map((item, index) => (
                  <div key={index}>
                    <div className="orderReceiptNode-row">
                      <div>{item.category}</div>
                      {/* <div>{item.details}</div> */}
                      <div>${item.cost.toFixed(2)}</div>
                    </div>
                    <hr className="orderReceiptNode-separator" />
                  </div>
                ))}
                <div className="orderReceiptNode-row orderReceiptNode-totalRow">
                  <div></div>
                  <div></div>
                  <div>Total: ${total}/mo</div>
                </div>
              </div>

              <hr className="orderReceiptNode-separator" />
              <ul className="orderReceiptNode-notes">
                <li>
                  <span className="orderReceiptNode-bullet">•</span> The
                  promotional rate of $89.95/mo is valid for the first 24 months
                  and is subject to the terms of your 24-month contract.
                </li>
                <li>
                  <span className="orderReceiptNode-bullet">•</span> An Early
                  Termination Fee of $20.00 applies if you cancel your service
                  before the 24-month contract ends.
                </li>
                <li>
                  <span className="orderReceiptNode-bullet">•</span> The WI-FI
                  Mesh Extender charge of $3.95/month will be added to your
                  monthly billing after a 90-day period.
                </li>
              </ul>
            </div>

            <div className="orderReceiptNode-section">
              <div className="orderReceiptNode-sectionHeader">
                <h4>One-Time Charges</h4>
              </div>
              <div className="orderReceiptNode-table">
                <div className="orderReceiptNode-row orderReceiptNode-header">
                  <div>Item</div>
                  <div>Item</div>
                  <div>Cost</div>
                </div>
                <hr className="orderReceiptNode-separator" />
                {installItems.map((entry, idx) => (
                  <div key={idx} className="orderReceiptNode-row">
                    <div>{entry.item}</div>
                    <div>{entry.type}</div>
                    <div>${entry.cost.toFixed(2)}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* <div className="orderReceiptNode-section">
              <div className="orderReceiptNode-sectionHeader">
                <h4>PRTC Residential monthly total</h4>
              </div>
              <div className="orderReceiptNode-row orderReceiptNode-header">
                <div>Your Payment Today</div>
                <div>$102.17</div>
              </div>

              <div className="orderReceiptNode-row">
                <div>Paid with</div>
                <div className="orderReceiptNode-creditCard">
                  <CreditCard size={16} />
                  <span>American Express ending in 8936</span>
                </div>
              </div>

              <hr className="orderReceiptNode-separator" />

              <div className="orderReceiptNode-row orderReceiptNode-bold">
                <div>Your Monthly Charges</div>
                <div>$102.17</div>
              </div>
            </div> */}

            {/* <div className="orderReceiptNode-detailsLinkContainer">
              <a className="orderReceiptNode-detailsLink" href="#">
                See Pricing Details
              </a>
            </div> */}

            <div className="orderReceiptNode-section">
              <div className="orderReceiptNode-sectionHeader">
                <h4>Recharge Preferences</h4>
              </div>
              <div className="orderReceiptNode-row">
                <div>Automatic Payment</div>
                <div>Auto Pay Enabled</div>
              </div>

              <hr className="orderReceiptNode-separator" />

              <div className="orderReceiptNode-row">
                <div>Recharge receipt</div>
                <div id="paperBilling">sam.lee@gmail.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="orderReceiptNode-footerRow">
        <p>
          <Mail />
          We’ll send a copy of this to <span>sam.lee@gmail.com</span>.
        </p>
        <div className="orderReceiptNode-buttonGroup">
          <Button
            customId={ELEMENT_IDS.PREVIOUS_STEP_BUTTON}
            label="Back"
            variant="secondary"
          />
          <Button
            customId={ELEMENT_IDS.NEXT_STEP_BUTTON}
            label="Submit Order"
            right={<span className={cx('orderReceiptNode-psnArrow')}>→</span>}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default OrderConfirmationNode;

